<section class="aca-mig__card aca-mig__cardpad">
  <label class="aca-mig__field" style="max-width: 420px">
    <span class="aca-mig__label">{{ 'DMS.MIGRATION.RECON_PICK_JOB' | translate }}</span>
    <select class="aca-mig__select" [ngModel]="selectedId()" (ngModelChange)="pick($event)">
      <option value="" disabled>{{ 'DMS.MIGRATION.PICK_JOB' | translate }}</option>
      <option *ngFor="let j of jobs()" [value]="j.id">{{ j.name }}</option>
    </select>
  </label>

  <div class="aca-mig__empty" *ngIf="!selectedId()">
    <mat-icon>compare_arrows</mat-icon>
    <div>{{ 'DMS.MIGRATION.RECON_EMPTY' | translate }}</div>
  </div>

  <ng-container *ngIf="selectedId()">
    <p class="aca-mig__notice" *ngIf="api.available() !== true">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.RECON_UNAVAILABLE' | translate }}</span>
    </p>

    <div class="aca-mig__tablewrap" *ngIf="api.available() !== true">
      <table class="aca-mig__table">
        <thead>
          <tr>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.RECON_CHECK' | translate }}</th>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="aca-mig__row" *ngFor="let c of checks; trackBy: trackByRow">
            <td class="aca-mig__td">{{ c | translate }}</td>
            <td class="aca-mig__td"><span class="aca-mig__chip">{{ 'DMS.MIGRATION.RECON_NOT_VERIFIED' | translate }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="api.available() === true">
      <button type="button" class="aca-mig__btn aca-mig__btn--primary" [disabled]="busy()" (click)="run()">
        {{ 'DMS.MIGRATION.RECON_RUN' | translate }}
      </button>
      <pre class="aca-mig__mono" *ngIf="result()" style="white-space: pre-wrap">{{ result() | json }}</pre>
    </ng-container>
  </ng-container>
</section>
